import { useCallback } from 'react';
import useFilters from 'shared/hooks/useFilters';
import { queryParamsList } from 'views/ActivityDataEntry';
import { isEditViewQuery } from 'constants/constants';
import {
  buildAdeSearchState,
  parseIsEditViewParam,
} from 'shared/utils/scopeThreeEditModeQuery';

/**
 * URL-driven edit/view mode for Scope 3 category routes (same `isEditView` query as Scope 1 ADE).
 * Use `clearEditModeParams` after `reset()` when the user cancels edit.
 */
export function useScopeThreeCategoryUrlMode() {
  const { getParams, setParams } = useFilters();

  const adeParams = getParams(queryParamsList);
  const isEditView = parseIsEditViewParam(adeParams[isEditViewQuery]);

  const enterEditMode = useCallback(() => {
    const latest = getParams(queryParamsList);
    setParams(
      buildAdeSearchState(latest, { withEditView: true }),
      undefined,
      true
    );
  }, [getParams, setParams]);

  const clearEditModeParams = useCallback(() => {
    const latest = getParams(queryParamsList);
    setParams(buildAdeSearchState(latest), undefined, true);
  }, [getParams, setParams]);

  return {
    adeParams,
    isEditView,
    enterEditMode,
    clearEditModeParams,
  };
}
